import NameCell from 'pages/companies/components/GridView/components/NameCell';

export const addLinkForNameCell = (columns) =>
  columns.map((col) => ({ ...col, cellRenderer: col.field === 'name' ? NameCell : undefined }));
